import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import InventarioMovimientosGrid from './InventarioMovimientosGrid.jsx';
import InventarioStockGrid from './InventarioStockGrid.jsx';
import InventarioStockIngresoAbm from './InventarioStockIngresoAbm.jsx';

/**
 * VEC-3313 / VEC-3314 / VEC-3315 — pantallas de stock del módulo de Inventario y Control de Stock v3.0.
 *
 * `/inventario/stock` es la grilla de Stock por Depósito (VEC-3313), que es el índice del módulo, y
 * de ella cuelgan el formulario de ingreso (VEC-3314), al que se entra con el ítem preseleccionado
 * desde la fila del catálogo o desde la fila de esta grilla, y el historial global de movimientos
 * (VEC-3315).
 *
 * Las tres pantallas comparten prefijo pero NO permiso: listar existencias
 * (INVENTARIO_STOCK_LISTAR), cargar stock (INVENTARIO_STOCK_INGRESAR) y ver el historial con sus
 * costos y responsables (INVENTARIO_STOCK_VISUALIZAR_MOVIMIENTOS) son tres audiencias distintas, y
 * cada pantalla valida el suyo.
 *
 * Mismo molde que InventarioItems.jsx / InventarioManoObra.jsx: header del módulo afuera y un
 * Switch adentro. El título se resuelve por ruta y no fijo, porque "Stock por Depósito" arriba de un
 * formulario de carga sería un encabezado que no describe la pantalla.
 */
const InventarioStock = ({ match }) => {
  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <Switch>
              <Route
                exact
                path={`${match.url}/ingresos/nuevo`}
                render={() => (
                  <FormattedMessage
                    id="inventarioStock.header_nuevo_ingreso"
                    defaultMessage="Nuevo Ingreso de Stock"
                  />
                )}
              />
              <Route
                exact
                path={`${match.url}/movimientos`}
                render={() => (
                  <FormattedMessage
                    id="inventarioStock.header_movimientos"
                    defaultMessage="Historial de Movimientos"
                  />
                )}
              />
              <Route
                render={() => (
                  <FormattedMessage id="inventarioStock.header_stock" defaultMessage="Stock por Depósito" />
                )}
              />
            </Switch>
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          {/* El formulario va ANTES del índice aunque las dos rutas sean `exact`: deja el orden
              leyéndose de lo más específico a lo más general, que es lo que evita sorpresas cuando
              alguna deje de serlo. */}
          <Route
            exact
            path={`${match.url}/ingresos/nuevo`}
            render={(props) => <InventarioStockIngresoAbm {...props} />}
          />
          <Route
            exact
            path={`${match.url}/movimientos`}
            render={(props) => <InventarioMovimientosGrid {...props} />}
          />
          <Route exact path={`${match.url}`} render={(props) => <InventarioStockGrid {...props} />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(InventarioStock);
